import { useEffect, useState } from "react";
import { classifyTemplate } from "../data/planRules";
import { listTemplates, type CVTemplate } from "../services/cvTemplateApi";

export const BASIC_DESIGN_CHECKOUT_REASON =
  "Basic Pass covers free designs only. Change your CV to a Free design, such as Classic Legacy, to buy Basic Pass, or choose Premium or above for this paid design.";

/** Carry the current draft's design into pricing, including header pricing links. */
export function useCheckoutDesign(
  explicitKey?: string | null,
  enabled = true,
  preferDraft = false,
) {
  let draft: { templateKey?: string; activeId?: string } = {};
  try {
    draft =
      JSON.parse(localStorage.getItem("cv_builder_session") ?? "{}") ?? {};
  } catch {
    // A missing or corrupt draft does not restrict standalone plan purchases.
  }
  const draftKey =
    typeof draft.templateKey === "string" ? draft.templateKey : undefined;
  const templateKey = enabled
    ? (preferDraft ? draftKey || explicitKey : explicitKey || draftKey) ||
      undefined
    : undefined;
  const [catalog, setCatalog] = useState<CVTemplate[] | null>(null);
  useEffect(() => {
    if (!templateKey) return;
    let active = true;
    void listTemplates().then((templates) => {
      if (active) setCatalog(templates);
    });
    return () => {
      active = false;
    };
  }, [templateKey]);

  const isLoading = Boolean(templateKey && !catalog);
  const isPaid = Boolean(
    templateKey && classifyTemplate(templateKey) === "PREMIUM",
  );
  const basicDisabledReason = isLoading
    ? "Checking which plans include your selected design…"
    : isPaid
      ? BASIC_DESIGN_CHECKOUT_REASON
      : undefined;
  const editorPath =
    typeof draft.activeId === "string" && draft.activeId
      ? `/editor?cv=${encodeURIComponent(draft.activeId)}`
      : "/editor";
  return {
    templateKey,
    isPaid,
    basicDisabledReason,
    editorPath,
    designLabel:
      catalog?.find((template) => template.key === templateKey)?.label ??
      templateKey,
  };
}
